import { z } from 'zod'
import { productLiteCategorized } from './product'

export const COUPON_CODE_REGEX = /^[A-Z0-9]{9}$/

// Matches a coupon code only when it's cleanly bounded by a real field
// separator ('|' or 'FF99') or the end of the string. Unlike
// COUPON_CODE_REGEX, this is safe to test against a raw scanned code that
// may have more fields after it (e.g. "UAMECK2AE|ECK2AE|Omar|94666444") —
// it can't be fooled by a coupon whose own 9 characters happen to contain
// the literal substring 'FF99' or '|', since it isn't a substring search.
export const COUPON_CODE_PREFIX_REGEX = /^[A-Z0-9]{9}(\||FF99|$)/

export const aopCheckCouponDto = z.object({
  code: z.string(),
  products: z.array(productLiteCategorized)
})
